export const MSTEAMS_INIT = "ms-teams/init";
export var ThemeClass;
(function (ThemeClass) {
    ThemeClass["Default"] = "teamsDefault";
    ThemeClass["Dark"] = "teamsDark";
    ThemeClass["HighContrast"] = "teamsHighContrast";
})(ThemeClass || (ThemeClass = {}));
